import { ClassAttributes, createElement, lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router';

const SigningInPage = lazy(() => import('../connected/SigningInPageConnected'));
const ResetPasswordRequestPage = lazy(() => import('../connected/ResetPasswordRequestPageConnected'));
const ResetPasswordPage = lazy(() => import('../connected/ResetPasswordPageConnected'));
const OtpRecoveryPage = lazy(() => import('../connected/OtpRecoveryPageConnected'));
const OtpPage = lazy(() => import('../connected/OtpPageConnected'));
const SignUpPage = lazy(() => import('../connected/SignUpPageConnected'));
const SignUpViaInvitationPage = lazy(() => import('../connected/SignUpViaInvitationPageConnected'));
const AgreementPage = lazy(() => import('../connected/AgreementPageConnected'));

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const SignedInScreen = ({ className }: Props) => (
  <div className={className}>
    <Suspense fallback={<div />}>
      <Switch>
        <Route exact sensitive path="/reset_password_request" component={ResetPasswordRequestPage} />
        <Route exact sensitive path="/reset_password" component={ResetPasswordPage} />
        <Route exact sensitive path="/otp_recovery" component={OtpRecoveryPage} />
        <Route exact sensitive path="/otp" component={OtpPage} />
        <Route exact sensitive path="/invitation" component={SignUpViaInvitationPage} />
        <Route exact sensitive path="/sign_up" component={SignUpPage} />
        <Route exact sensitive path="/agreement" component={AgreementPage} />
        <Route sensitive path="/" component={SigningInPage} />
      </Switch>
    </Suspense>
  </div>
);

export default SignedInScreen;
